import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ visible, title = 'Confirmar acción', message, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div className="confirm-overlay">
      <div className="confirm-modal" role="dialog" aria-modal="true">
        <h3 className="confirm-title">{title}</h3>
        <div className="confirm-message">{message}</div>
        <div className="confirm-actions">
          <button className="btn-cancel" onClick={onCancel}>Cancelar</button>
          <button className="btn-confirm" onClick={onConfirm}>Eliminar</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
